import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import FormComponent from 'dataphi-react-components/dist/Containers/FormScreen/FormComponent'

import HSGCard from '../../../Components/HSGCard/HSGCard'
import OrganizationDefs from './OrganizationDefs'
import history from '../../../history'

import Constants from '../../../Phi/Constants'

import './ManageProfile.css'

class ManageProfile extends Component {
    constructor(props){
        super(props)
        this.state = {
            initialFetch: true
        }
    }

    componentWillMount() {
        this.getOrg(this.props)
        this.props.initializeForm({})
    }

    prepareForm = (props) => {
        if(props && props.formData && this.state.initialFetch){
            this.props.initializeForm(props.formData)
            this.setState({initialFetch: false})
        }
    }

    fetchOrg = (props) => !!!Object.keys(props.organization).length && props.getOrg(props.inOrganizationId)

    getOrg = (props) => props.inOrganizationId ? this.fetchOrg(props) : history.replace('/dashboard')
    componentWillReceiveProps(newProps) {
        if(JSON.stringify(newProps.formData) !== JSON.stringify(this.props.formData)) this.prepareForm(newProps)
        this.getOrg(newProps)
    }

    handeOrgDetailsChange = (data) => {
        const schoolContactPersonDetail = {
            ...this.props.schoolContactPersonDetails[0],
            contactNo: data.contactNo
        }
        let dataToSend = {
            ...data,
            schoolContactPersonDetails: this.props.schoolContactPersonDetails.length > 1 ? [
                schoolContactPersonDetail,
                this.props.schoolContactPersonDetails.slice(1)
            ] : [schoolContactPersonDetail]
        }
        delete dataToSend.emailId
        delete dataToSend.contactNo
        this.props.updateOrganization(this.props.inOrganizationId, dataToSend)
        history.replace('/dashboard')
    }


    render() {

        let orgDefs = OrganizationDefs
        let submitButton = {
            submitButton: {
                text: 'Update Profile',
                className: {
                  fieldClassName: "btn hsg-btn-primary wide",
                  groupClassName: "wide",
                }
            },
        }

        let submitButtonHidden = {
            submitButton: {
                text: 'Update Profile',
                className: {
                  fieldClassName: "btn hsg-btn-primary wide",
                  groupClassName: "wide",
                },
                hide: true
            },
        }

        orgDefs = Object.assign({}, orgDefs, this.props.roleType && Constants.userPermissionMap[this.props.roleType].includes(Constants.userPermissionId.EDIT) ? submitButton : submitButtonHidden)

        return (
            <section className="hsg-default-background" >
                <Row>
                    <Col xs={12} sm={6} smOffset={3}>
                        {/* Main Content */}
                        <HSGCard full hideHeader>                                                    
                            <div>
                                <br/><br/>
                                <FormComponent 
                                    formDefs={orgDefs} 
                                    onSubmit={(data) => this.handeOrgDetailsChange(data)} 
                                    onFieldBlur={(input) => {}} 
                                />
                            </div>                                
                        </HSGCard>
                    </Col>
                </Row>
            </section>
        );
    }

}


export default ManageProfile


// WEBPACK FOOTER //
// ./src/Containers/ManageProfileContainer/Component/ManageProfile.js